import { Injectable, inject } from '@angular/core';
import { EnrollhereApiService } from '../enrollhere-api/enrollhere-api';

export interface SepCounty {
  fips: string;
  name: string;
  state: string;
  zip_area_pct: number;
}

export interface SepCode {
  code: string;
  name: string;
  available: boolean;
  period: string;
  evidence: string;
  cms_reference: string;
}

export interface SepLookupResult {
  disclaimer: string;
  zip_code: string;
  counties: SepCounty[];
  primary_county_name: string;
  state: string;
  sep_codes: SepCode[];
}

/**
 * ZIP-based Special Enrollment Period lookup, shared-submodule twin of the
 * dialer's SepLookupService so common components (e.g. the consumer detail
 * form) can offer the same "Show Available SEP" affordance without a
 * dependency on the host app's services.
 */
@Injectable({ providedIn: 'root' })
export class SepLookupApiService {
  private readonly api = inject(EnrollhereApiService);

  async lookupSepsByZip(zipCode: string): Promise<SepLookupResult> {
    const result = await this.api.get<{ data: SepLookupResult }>(
      `dialer/sep-lookup/${encodeURIComponent(zipCode)}`
    );
    return result.data;
  }
}
